<template>
    <div class="columns is-multiline is-mobile day-container" :class="{'details': details || print, 'print': print}" @click="details=true">
        <div class="column is-narrow is-hidden-mobile">
            <date-label :date="day.day_on" :print="print"/>
        </div>
        <div class="column content">
            <div v-if="details || print">
                <img class="day-photo" :src="'/api/day_photos/img/' + day.photos[0].file + '/day'" v-if="day.photos && day.photos[0]"/>
                <h3 class="mt-2 mb-2">{{ day.title }}</h3>
                <div class="mb-4 meta">{{ day.day_on | moment('dddd, MMMM Do YYYY')}}</div>
                <div class="mb-5" style="color: #525252">{{day.description}}</div>

                <div class="mb-6" v-if="!print"><b-button type="is-primary" outlined @click.stop="details=false"><i class="far fa-magnifying-glass-minus mr-2"></i>Hide Details</b-button></div>
                <div v-for="event in day.events" class="event" v-if="event.active !== '0'">
                    <div v-if="event.type==='custom_event'">
                        <h6>{{event.title}}</h6>
                        <div class="mb-4 mr-6 critical" v-if="event.critical_info">{{event.critical_info}}</div>
                        <div v-if="event.description" class="mb-4 mr-6 content ql-editor" v-html="event.description"></div>
                        <div v-if="event.documents && event.documents.length" class="mb-4 mr-6">
                            <div v-for="doc in event.documents" class="document columns is-mobile is-gapless">
                                <div class="column is-narrow">
                                    <i class="far fa-file fa-fw mr-2"></i>
                                </div>
                                <div class="column">
                                    <div class="has-text-weight-bold">{{doc.subject}}</div>
                                    <div v-if="doc.id_number">{{doc.id_number}}</div>
                                    <div v-if="doc.information" class="mt-2">{{doc.information}}</div>
                                </div>
                                <div class="column is-narrow">
                                    <b-button type="is-primary is-outlined is-small" @click.stop="viewCustomFile(doc, event)"><i class="fas fa-eye mr-2"></i>View</b-button>
                                </div>
                            </div>
                        </div>
                        <div v-if="!event.time && event.start_at && event.end_at"><i class="far fa-clock fa-fw mr-2"></i>{{event.start_at | moment('timezone', event.start_tz, 'h:mm A')}} - {{event.end_at | moment('timezone', event.end_tz, 'h:mm A')}}</div>
                        <div v-if="event.time"><i class="far fa-clock fa-fw mr-2"></i>{{event.time}}</div>
                        <div class="meta" v-if="event.location"><i class="far fa-map-marker fa-fw mr-2"></i>{{event.location}}</div>
                    </div>

                    <div v-else-if="event.type==='override_event'">
                        <h6>{{event.day_event.title}}</h6>

                        <div class="mb-4 mr-6 critical" v-if="event.day_event.critical_info">{{event.critical_info}}</div>
                        <div class="mb-4 mr-6 vendor ql-editor" v-if="isStaff && event.day_event.vendor_info">
                            <div class="vendor-label"><i class="far fa-truck fa-fw mr-2"></i>Vendor Info &middot; Staff</div>
                            <div v-html="event.day_event.vendor_info"></div>
                        </div>
                        <div v-if="event.day_event.description" class="mb-4 mr-6 content ql-editor" v-html="event.day_event.description"></div>

                        <div class="meta" v-if="!event.day_event.time && event.day_event.start_at && event.day_event.end_at"><i class="far fa-clock fa-fw mr-2"></i>{{event.day_event.start_at | moment('timezone', event.day_event.start_tz, 'h:mm A')}} - {{event.day_event.end_at | moment('timezone', event.day_event.end_tz, 'h:mm A')}}</div>
                        <div class="meta" v-if="event.day_event.time"><i class="far fa-clock fa-fw mr-2"></i>{{event.day_event.time}}</div>
                        <div class="meta"><i class="far fa-map-marker fa-fw mr-2"></i>{{event.day_event.location}}</div>
                    </div>
                    <flight-event :event="event" v-else-if="event.type==='flight'"/>
                    <div v-else>
                        <h6>{{ event.title }}</h6>
                        <div class="mb-4 mr-6 critical" v-if="event.critical_info">{{event.critical_info}}</div>
                        <div class="mb-4 mr-6 vendor ql-editor" v-if="isStaff && event.vendor_info">
                            <div class="vendor-label"><i class="far fa-truck fa-fw mr-2"></i>Vendor Info &middot; Staff</div>
                            <div v-html="event.vendor_info"></div>
                        </div>
                        <div v-if="event.description" class="mb-4 mr-6 content ql-editor" v-html="event.description"></div>
                        <div v-if="event.documents && event.documents.length" class="mb-4 mr-6">
                            <div v-for="doc in event.documents" class="document columns is-mobile is-gapless">
                                <div class="column is-narrow">
                                    <i class="far fa-file fa-fw mr-2"></i>
                                </div>
                                <div class="column">
                                    <div class="has-text-weight-bold">{{doc.subject}}</div>
                                    <div v-if="doc.id_number">{{doc.id_number}}</div>
                                    <div v-if="doc.information" class="mt-2">{{doc.information}}</div>
                                </div>
                                <div class="column is-narrow">
                                    <b-button type="is-primary is-outlined is-small" @click.stop="viewFile(doc)"><i class="fas fa-eye mr-2"></i>View</b-button>
                                </div>
                            </div>
                        </div>
                        <div v-if="!event.time && event.start_at && event.end_at"><i class="far fa-clock fa-fw mr-2"></i>{{ event.start_at | moment('timezone', event.start_tz, 'h:mm A') }} - {{ event.end_at | moment('timezone', event.end_tz, 'h:mm A') }}</div>
                        <div v-if="event.time"><i class="far fa-clock fa-fw mr-2"></i>{{ event.time }}</div>
                        <div class="meta" v-if="event.location"><i class="far fa-map-marker fa-fw mr-2"></i>{{ event.location }}</div>
                    </div>
                </div>
            </div>
            <div v-else>
                <img :src="'/api/day_photos/img/' + day.photos[0].file + '/day'" class="preview is-pulled-left mb-0 mr-5" style="height: 89px" v-if="day.photos && day.photos[0]"/>
                <div v-else class="photo-frame is-pulled-left mb-0 mr-5"><i class="fat fa-calendar-day"></i></div>

                <h4 class="pt-1 mb-1">{{ day.title }}</h4>
                <div class="mb-2 meta">{{ day.day_on | moment('dddd, MMMM Do YYYY')}}</div>

                <div class="meta"><i class="fas fa-search mr-2"></i>{{count}} Event<span v-if="count !== 1">s</span></div>
            </div>
        </div>
    </div>
</template>

<script>
    import DateLabel from "./DateLabel";
    import FlightEvent from "./FlightEvent";
    import {client as http, url} from "../http_client";
    import {mapGetters} from "vuex";


    export default {
        name: "ItineraryDay",
        components: {FlightEvent, DateLabel},
        props: {
            day: {
                required: true
            },
            print: {
                type: Boolean,
                default: false
            }
        },
        data: function() {
            return {
                details: false,
                apiUrl: url
            }
        },
        computed: {
            ...mapGetters(['trip', 'registration']),
            isStaff: function() {
                return this.registration.type === 'staff' || this.registration.second_type === 'staff';
            },
            count: function() {
                let result = 0;
                for (let i = 0; i < this.day.events.length; i++) {
                    const evt = this.day.events[i];
                    if (evt.active !== '0') result++;
                }
                return result;
            }
        },
        methods: {
            viewFile: function(doc) {
                window.open(this.apiUrl + 'api/trips/' + this.day.trip_id + '/days/' + this.day.id + '/events/' + this.day.event_id + '/documents/file/' + doc.file, '_blank');
            },
            viewCustomFile: function(doc, event) {
                window.open(this.apiUrl + 'api/registrations/' + this.registration.id + '/events/' + this.day.id + '/' + event.id + '/documents/file/' + doc.file, '_blank');
            }
        }
    };
</script>

<style lang="scss" scoped>
    .day-container {
        margin: 0.05px 0.05px 1rem;
        background-color: white;
        border-radius: 0.3rem;
        position: relative;
        padding: 0.05px;
        cursor: pointer;

        &.details {
            margin-bottom: 3rem;
            cursor: default;
        }

        @media only screen and (max-width: 768px) {
            h4 {
                font-size: 1rem;
            }
        }

        &.print {
            .day-photo {
                max-width: 200px;
            }
        }
    }

    img {
        border-radius: 0.3rem;
        margin-bottom: 1rem;

        &.preview {
            @media only screen and (max-width: 500px) {
                display: none;
            }
        }

    }

    .photo-frame {
        border-radius: 0.3rem;
        margin-bottom: 1rem;
        border: 1px solid #eee;
        width: 102px;
        height: 68px;
        text-align:  center;

        i {
            color: #eee;
            font-size: 2.6rem;
            margin-top: 13px;
        }

        @media only screen and (max-width: 500px) {
            display: none;
        }
    }

    .event {
        font-size: 0.85rem;
        border-top: 2px solid #eee;
        padding: 1rem 0;

        h6 {
            font-size: 1rem;
        }

        .critical {
            border: 1px solid red;
            background-color: #fae8e8;
            border-radius: 8px;
            padding: 1rem 1.2rem;
        }

        .vendor {
            border: 1px solid #628b21;
            background-color: #f2f6ea;
            border-radius: 8px;
            padding: 0.8rem 1.2rem;

            .vendor-label {
                font-size: 0.75rem;
                font-weight: 700;
                text-transform: uppercase;
                letter-spacing: 0.03em;
                color: #628b21;
                margin-bottom: 0.4rem;
            }
        }

        .document {
            border-left: 2px #628b21 solid;
            padding: 0.6rem 0.6rem 0.6rem 8px;
            background: rgba(244, 244, 244, 0.86);
            border-top-right-radius: 8px;
            border-bottom-right-radius: 8px;

            i.fa-file {
                color: #628b21;
                font-size: 1.1rem;
            }
        }
    }

    .meta {
        font-size: 0.85rem;
        color: #424242;
    }
</style>
